import { Button, Icons, Input, Stack, ToggleButtonGroup } from '@healthinal/ui';
import { useAtom } from 'jotai';
import { useEffect, useRef, useState } from 'react';
import {
  tracingContactSearchTextAtom,
  TracingContactTableFilter,
  tracingContactTableFilterAtom,
} from '../../../../state/tracingContactSearchAtoms.ts';
import { getTracingContactTableFilterName } from '../../../../utils/tracingContactSearch/tracingContactTableFilter.ts';

export function TracingContactTableSearch() {
  const [tableFilter, setTableFilter] = useAtom(tracingContactTableFilterAtom);
  const [committedSearch, setCommittedSearch] = useAtom(tracingContactSearchTextAtom);
  const [draft, setDraft] = useState(committedSearch);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    setDraft(committedSearch);
  }, [committedSearch]);

  const handleChange = (value: string) => {
    setDraft(value);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => setCommittedSearch(value), 900);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      clearTimeout(debounceRef.current);
      setCommittedSearch(draft);
    }
  };

  return (
    <Stack direction="row" justifyContent={'space-between'}>
      <ToggleButtonGroup value={tableFilter}>
        {Object.values(TracingContactTableFilter).map((filter) => (
          <Button key={filter} value={filter} onClick={() => setTableFilter(filter)}>
            {getTracingContactTableFilterName(filter)}
          </Button>
        ))}
      </ToggleButtonGroup>
      <Input
        placeholder={'Kontaktperson suchen'}
        endDecorator={<Icons.Search />}
        value={draft}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </Stack>
  );
}
